import getParameterByName from '../../../../../@infinite/scripts/core/INF-getParameterByName';

export default (country_code, domain, from_script = false) => {
  let search = window.location.search;

  if (window.location.search.indexOf('?') === -1) {
    search = `?country=${country_code}`;
  } else if (!getParameterByName('country')) {
    search = `${window.location.search}&country=${country_code}`;
  } else {
    const old_country_code = getParameterByName('country');
    const old_country_query = `country=${old_country_code}`;
    const country_query = `country=${country_code}`
    search = window.location.search.replace(old_country_query, country_query);
  }

  if (from_script && !getParameterByName('redirect')) {
    search += '&redirect=true';
  } else if (!from_script && getParameterByName('redirect')) {
    search = search.replace('&redirect=true', '');
  }

  return `${window.location.protocol}//${domain}${window.location.pathname}${search}${window.location.hash}`;
};
